import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { ActionStatus, ActionType } from "../../data/crmGeneralData";
import { useGetCustomer, useEditData } from "../../hooks/useCrm";
import { DataPicker } from "../DataPicker/DataPicker";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
import Converter from "persian-date-converter";
import { useParams } from "react-router-dom";
import { useMemo } from "react";

const initvalue = {
  IdActivityCrm: null,
  SubjectActivityCrm: "",
  DescriptionActivityCrm: "",
  StatusActivityCrm: "",
  DateReferenceActivityCrm: "",
  AnswerActivityCrm: "",
  IdS0alesOpportunities: null,
  meIdUserSabtActivityCrm: null,
};
export const EditActionModal = ({ show, handleClose, editActionData }) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initvalue);
  const { mutateAsync: EditAction } = useEditData();
  const [actionDate, SetActionDate] = useState();
  const _date = new Converter();
  var setDateReferenceFunction;
  useMemo(() => {
    if (editActionData) {
      setDateReferenceFunction = () => {
        const createDate = editActionData?.DateReferenceActivityCrm;
        var year = createDate.slice(0, 4);
        var month = createDate.slice(5, 7);
        var day = createDate.slice(8, 10);
        var date = year + "-" + month + "-" + day;
        var dateWrapper = _date.convert(date, "fa");
        var changedDate = dateWrapper.replace(/\//g, "-");
        SetActionDate(changedDate);
        return changedDate;
      };
      setForm({
        ...form,
        IdActivityCrm: editActionData?.IdActivityCrm,
        SubjectActivityCrm: editActionData?.SubjectActivityCrm,
        StatusActivityCrm: editActionData?.StatusActivityCrm,
        DescriptionActivityCrm: editActionData?.DescriptionActivityCrm,
        DateReferenceActivityCrm: setDateReferenceFunction(),
        meIdUserSabtActivityCrm: editActionData?.IdUserSabtActivityCrm
          ? editActionData?.IdUserSabtActivityCrm
          : editActionData?.IdUser,
        AnswerActivityCrm: editActionData?.AnswerActivityCrm,
        IdS0alesOpportunities: editActionData?.IdS0alesOpportunities,
      });
    }
  }, [editActionData]);
  const actionType = ActionType.map((action) => {
    return {
      value: action.value,
      label: action.label,
    };
  });
  const actionStatus = ActionStatus.map((action) => {
    return {
      value: action.value,
      label: action.label,
    };
  });
  const { data: customerresponsible } = useGetCustomer();
  const customerResponsible = customerresponsible?.data?.Colleague;
  const customerResponsibleOptions = customerResponsible?.map((res) => {
    return {
      value: res.IdUser,
      label: res.FirstName + " " + res.LastName,
    };
  });
  const setDateFunction = (date) => {
    const finalDate = date?.year + "-" + date?.month + "-" + date?.day;
    setForm({ ...form, DateReferenceActivityCrm: finalDate });
  };
  const handleEditAction = async (data) => {
    await EditAction(data).then(() => setForm(initvalue));
  };

  return (
    <BootstrapModal
      modaltitle="ویرایش فعالیت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="lg"
      closebutton={
        <Button
          style={{ width: "40px", border: "none" }}
          onclick={() => {
            handleClose();
            setForm(initvalue);
          }}
        >
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <SimpleSelect1
            label={"عنوان فعالیت"}
            res={actionType}
            onChange={(e) =>
              setForm({
                ...form,
                SubjectActivityCrm: e.value,
              })
            }
            placeholder={editActionData?.SubjectActivityCrm}
          />
        </div>
        <div className="col-6">
          <SimpleTextArea
            label="توضیح فعالیت"
            cols="10"
            rows="3"
            placeholder="توضیح فعالیت را بنویسید..."
            onChange={(e) =>
              setForm({ ...form, DescriptionActivityCrm: e.target.value })
            }
            value={form?.DescriptionActivityCrm}
          />
        </div>
        <div className="col-6">
          <SimpleTextArea
            label="پاسخ فعالیت"
            cols="10"
            rows="3"
            placeholder="پاسخ فعالیت را بنویسید..."
            onChange={(e) =>
              setForm({ ...form, AnswerActivityCrm: e.target.value })
            }
            value={form.AnswerActivityCrm}
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12">
          <SimpleSelect1
            label={"وضعیت"}
            res={actionStatus}
            onChange={(e) =>
              setForm({
                ...form,
                StatusActivityCrm: e.value,
              })
            }
            placeholder={editActionData?.StatusActivityCrm}
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12">
          <SimpleSelect1
            label={"تغییر مسئول"}
            res={customerResponsibleOptions}
            onChange={(e) =>
              setForm({
                ...form,
                meIdUserSabtActivityCrm: e.value,
              })
            }
            placeholder={
              editActionData?.FirstName + " " + editActionData?.LastName
            }
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12">
          <DataPicker
            label={`تاریخ فعالیت (تاریخ قبلی ${actionDate})`}
            onChange={(event) => {
              if (event !== undefined) {
                setDateFunction(event);
              }
            }}
            placeholder="تغییر تاریخ"
          />
        </div>
        <div className="col-12">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleEditAction(form);
              handleClose();
            }}
          >
            تایید
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
